import {i18n} from 'src/i18n';
import schemas from 'src/modules/shared/yup/yupImporterSchemas';

export default [
  {
    name: 'name',
    label: i18n('entities.project.fields.name'),
    schema: schemas.string(i18n('entities.project.fields.name'), {
      required: true,
    }),
  },
  {
    name: 'code',
    label: i18n('entities.project.fields.code'),
    schema: schemas.string(i18n('entities.project.fields.code'), {}),
  },
];
